import React from "react";

const CardsComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default CardsComponent;
